// extracted by mini-css-extract-plugin
export default {"prompt":"EmailConfirmFirstStep_prompt_wdFbD","button":"EmailConfirmFirstStep_button_si4ky","label":"EmailConfirmFirstStep_label_fh2IT"};